var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngularjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.16.001 1.998 9.913l4.45 36.899 23.744 13.05 23.865-13.227 4.45-36.898L30.16.001Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.696 11.87 30.095 3.14v53.603L51.549 44.87l4.147-33Z",
    fill: "#A6120D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.157 12.027 3.814 33 21.123 11.717V3.139L5.157 12.027Z",
    fill: "#DD1B16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m37.143 31.675-7.047 3.296h-7.428l-3.491 8.733-6.494.12L30.096 5.086l7.047 26.59Zm-.681-1.659-6.32-12.51-5.183 12.295h5.136l6.367.216Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m30.095 5.086.046 12.42 5.882 12.305h-5.915l-.013 5.152 8.178.008 3.823 8.854 6.214.115L30.095 5.087Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularjs);
export default __webpack_public_path__ + "static/media/angularjs.16a6b7c39b52b6a8409a48a397d4b720.svg";
export { ForwardRef as ReactComponent };